<template>
  <el-form-item :label="form.name" :prop="form.model"
                :class="[form.options.required?'label-blue':'']"
                :rules="form.rules"
                :required="form.options.required"
                v-show="!form.options.hidden"
                 style="padding-left:10px;line-height:36px;"
  >
     <el-input v-model="value[form.model]"
              type="number"
              :placeholder="form.options.placeholder"
              :disabled="inputDisable"
              @input="onInput"
              @focus="onFocus"
              :controls="false"
              clearable
              
              style="width:226px"
              >
              </el-input>
  </el-form-item>
</template>

<script>
export default {
  name: 'LongAndLat',
 data () {
    return {
      key: '',
      formData: {},
      mainValue: ''
    }
  },
  props: {
    form: {
      type: Object,
      // eslint-disable-next-line vue/require-valid-default-prop
      default: () => {
        return {
          name: '',
          prop: '',
          icon: '',
          className: '',
          options: {
            width: '100%',
            defaultValue: '',
            required: false,
            dataType: 'string',
            pattern: '',
            placeholder: '',
            max:0,
            min:0,
            customClass: '',
            disabled: false,
            remoteFunc: () => {},
            changeFunc: () => {}
          },
          key: '',
          model: 'value',
          rules: [{}]
        }
      }
    },
    value: Object,
    forms: {
      type: Object,
      default: () => { return {} }
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  model: {
    prop: 'value',
    event: 'input'
  },
  watch: {
    value: {
      immediate: true,
      handler: function (val, oldVal) {
        this.mainValue = val
      }
    }
  },
  methods: {
    onInput (val) {
      let that = this
      let reg = /^(0(?!\.0{1,2}$)(\.[0-9]{1,2})?|[1-9][0-9]{0,2}(\.[0-9]{1,10})?)$/
      if(reg.test(val)){
            that.value[that.form.model]=val
      }else{
          that.value[that.form.model] = val.slice(0,val.length-1)
      }

      that.$emit('input', that.value, that.form.model)
      if (typeof that.form.options.changeFunc === 'function') { // 判断是否存在数据改变事件
        that.form.options.changeFunc(that.value[that.form.model], that, that.forms)
      }
    },
    setValue (val) {
      this.mainValue = val
    },
    onFocus (val) {
      let that = this
      if (typeof that.form.options.onFocus === 'function') { // 判断是否存在数据改变事件
        that.form.options.onFocus()
      }
    }
  },
  created () {
    let that = this
    that.key = that.form.key
    if (that.form.hasOwnProperty('options')) {
      that.value[that.form.model] = that.value[that.form.model] || this.form['options']['defaultValue'] || ''
    }
  },
  mounted () {
    let that = this
    that.$emit('init', that.key, that)
  },
  computed: {
    inputDisable () {
      return this.disabled || this.form.options.disabled
    }
  }
}
</script>

<style scoped>
/* 旧 */
/* .el-form-item /deep/ input::-webkit-outer-spin-button,
.el-form-item /deep/ input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
.el-form-item /deep/ input[type="number"]{
  -moz-appearance: textfield;
} */

/* 新 */
.el-form-item deep(input::-webkit-outer-spin-button) ,
.el-form-item deep(input::-webkit-inner-spin-button)  {
  -webkit-appearance: none;
}
.el-form-item deep(input[type="number"]) {
  -moz-appearance: textfield;
}
</style>
<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/components/DynamicPages/Customize/LongAndLat.vue"
}
</vue-filename-injector>
